import {
  AutoComplete,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
} from "antd";
import { FormInstance } from "antd/lib/form/Form";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import type { InputRef } from "antd";
import { FIELD_TYPE, FORMAT_TIME, LOAI_PHIEU_KHO } from "types/enums";
import dayjs from "dayjs";
import { useAppSelector } from "redux/hooks";
import { pharmacyStoreService, catalogService, storeService } from "api";
import moment from "moment";
import {
  formatToCurrencyTypeToFixed,
  isValuableString,
  toNumber,
} from "helper/common";

import { Rule } from "antd/es/form";

type EditableRowProps = {
  index: number;
};
const { INPUT, DATE, COMBO_BOX, BUTTON } = FIELD_TYPE;
export type EditableCellProps = {
  title: React.ReactNode;
  editable?: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any[];
  name: string;
  index: number;
  type: FIELD_TYPE;
  disabled?: boolean;
  value?: any;
  onChange?: (e) => void;
  handleSave: (record, index) => void;
  onFocus?: () => void;
  onPressEnter?: (e) => void;
  addonAfter?: any;
  initRules?: Rule[];
  hidden?: boolean;
  autoFocus?: boolean;
  form?: any;
  setTongTien?: any;
};

export const EditableContext = React.createContext<FormInstance<any> | null>(
  null
);

export const EditableRow: React.FC<EditableRowProps> = ({
  index,
  ...props
}) => {
  return (
    <>
      <tr {...props} />
    </>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  handleSave,
  name,
  index,
  type,
  onChange,
  onPressEnter,
  disabled,
  value,
  hidden,
  form,
  autoFocus,
  initRules,
  ...restProps
}) => {
  // const [newOptions, setNewOptions] = useState(options);
  const setFieldValue = (dataIndex: string, value: any) => {
    form?.setFieldValue([name, index, dataIndex], value);
  };
  const getFieldValue = (dataIndex: string) => {
    return form?.getFieldValue([name, index, dataIndex]);
  };

  let childNode = children;
  const handleAddTime = (e) => {
    //tách giá trị đầu vào bỏ dấu + chỉ lấy số
    const validValue = +e;
    if (getFieldValue("thoiGianBatDau")) {
      const currentTime = dayjs(getFieldValue("thoiGianBatDau"));
      const newTime = currentTime.add(validValue, "minute").toISOString();
      setFieldValue("thoiGianKetThuc", dayjs(newTime));
    }
  };
  if (type == INPUT) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
      >
        <Input
          placeholder={disabled ? "--" : "Nhập"}
          disabled={disabled}
          onClick={() => {}}
          onChange={async (e) => {}}
        ></Input>
      </Form.Item>
    );
  }
  if (type == DATE) {
    childNode = (
      <Form.Item name={[name, index, dataIndex]} initialValue={null}>
        <DatePicker
          disabled={disabled}
          onChange={() => {}}
          format={FORMAT_TIME.dateTime.toString()}
          showTime={true}
          needConfirm={false}
        />
      </Form.Item>
    );
  }

  if (type == COMBO_BOX) {
    childNode = (
      <Form.Item
        style={{ margin: 0 }}
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
      >
        <Select
          showSearch
          style={{
            // width: "100%",
            maxWidth: "150px",
          }}
          filterOption={(input, option) =>
            (option?.label.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          placeholder={disabled ? "--" : "Chọn"}
          options={options}
          disabled={disabled}
          allowClear={true}
          onChange={(e) => {}}
          onClick={async (e) => {}}
          {...restProps}
        />
      </Form.Item>
    );
  }

  if (type == BUTTON) {
    childNode = (
      <Row justify={"space-between"} gutter={5}>
        {[5, 8, 10].map((el, i) => (
          <Col span={8}>
            <Button
              onClick={(e) => {
                handleAddTime(el);
              }}
            >
              +{el}
            </Button>
          </Col>
        ))}
      </Row>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
